<!--start section header-->
 
<header class="head">
    <div class="cover">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5 d-flex justify-content-center">
                Contacts
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb d-flex justify-content-center">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">Contacts</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->

  <!--start section contactForm-->
    
  <section class="pt-5 container">
    <div class="contact">
      <div class="contact-head d-flex justify-content-center pb-3">
        <h2>Contact Form</h2>
      </div>
      <div class="row pt-3 ">


        <div class="col-lg-6 contact-content mb-3">
          <div class="w-75 m-auto">
            <input type="text" class="form-control text-center" placeholder="Name" aria-label="First name">
          </div>
        </div>
        <div class="col-lg-6 contact-content mb-3">
          <div class="w-75 m-auto">
            <input type="email" class="form-control text-center" placeholder="Email Address" aria-label="Email">
          </div>
        </div>
        <div class="col-lg-6 contact-content mb-3">
          <div class="w-75 m-auto">
            <input type="number" class="form-control text-center" placeholder="Phone number" aria-label="Phone">
          </div>
        </div>
        <div class="col-lg-6 contact-content mb-3">
          <div class="w-75 m-auto">
            <input type="text" class="form-control text-center" placeholder="Your Subject" aria-label="Subject">
          </div>
        </div>
        <div class="col-lg-12 contact-content mb-3">
          <div class="w-75 m-auto">
            <textarea class="form-control text-area text-center" placeholder="Message..." id="exampleFormControlTextarea1" rows="5"></textarea>
          </div>
        </div>
        <div class="m-auto">
          <button class="btn btn-outline-danger mt-4">Send Message</button>
        </div>


       </div>
    </div>
   </section>

<!--end section contactForm-->